/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shipping_Weight_MissingInputs */

const vi_error_shipping_weight_missing = /** @type {(inputs: Error_Shipping_Weight_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có sản phẩm chưa nhập khối lượng nên chưa tính được phí ship. Nhập khối lượng ở form sản phẩm.`)
};

/**

* @param {Error_Shipping_Weight_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shipping_weight_missing = /** @type {((inputs?: Error_Shipping_Weight_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shipping_Weight_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shipping_weight_missing(inputs)
});